<template>
  <div class="main">
    <FormWrapper :action="formAction" method="PUT">
      <div class="title-bar">
        <h1 class="mb-0">Edit Help Article</h1>
        <a class="btn-back" :href="route('admin.help.articles.index')">
          <span class="icon icon-arrow-left"></span>
          <span class="text">Back to List</span>
        </a>
      </div>
      <div class="row no-gutters py-4">
        <div class="col-12 col-lg-8 col-xl-9">
          <div class="row no-gutters pl-4">
            <div class="col-12">
              <transition name="fade">
                <Alert v-if="hasAlert" :alert="alert" />
              </transition>
            </div>
            <div class="col-12 mb-3">
              <Field
                type="text"
                name="title"
                label="Title"
                :value="article.title"
                validate="required"
              />
            </div>
            <div class="col-12 mb-3">
              <HtmlField
                name="content_student"
                label="Public/Dealer Help Content"
                :value="article.content_student"
              />
            </div>
            <div class="col-12 mb-3">
              <HtmlField
                name="content_manager"
                label="Distributor Help Content"
                :value="article.content_manager"
              />
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4 col-xl-3 form-button-wrapper">
          <div class="sticky-top">
            <div class="row no-gutters text-center">
              <div class="col-12">
                <h4 class="text-uppercase text-center">Status</h4>
                <SwitchField
                  name="is_enabled"
                  on-label="Enabled"
                  off-label="Disabled"
                  :value="!!article.is_enabled ? 1 : 0"
                />
                <hr class="w-75" />
              </div>
              <div class="col-12 pb-3">
                <button type="submit" class="btn btn-success w-50">
                  Save Changes
                </button>
              </div>
              <div class="col-12 pb-3">
                <a
                  :href="route('admin.help.articles.index')"
                  class="btn btn-danger w-50"
                  >Cancel & Exit</a
                >
              </div>
              <div class="col-12 font-size-sm text-center pt-4">
                <span
                  >Last updated on
                  {{ article.updated_at | moment("MM/DD/YYYY") }}</span
                >
                <span>at {{ article.updated_at | moment("h:mma") }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FormWrapper>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
export default {
  mixins: [DisplaysAlerts],
  props: {
    article: { type: Object, required: true },
  },
  computed: {
    formAction() {
      return this.route("admin.help.articles.update", {
        article: this.article.view,
      });
    },
  },
};
</script>